var jQuery = require('jquery');
require('../../third/jquery.cookie');

(function($, window, document, undefined ) {
	"use strict";

	console.warn('DEPRECATED COMPONENT - use fg-frontend/components/CookiePolicy');

	var PLUGIN_NAME = "cookiesPolicy";
	var PLUGIN_VERSION = "v1.2";

	var	DEFAULTS = {
		lang: 'en',
		position: 'top',
		acceptEffect: 'slideUp',	// slideUp | fadeOut
		css: {
			brandColor: '#f63',
			panel: {
				'position': 'static',
				'color': '#fff',
				'background-color': 'rgba(0,0,0,0.9)',
				'padding-top': '1em',
				'padding-bottom': '1em',
				'z-index': 2147483647,
				'width': '100%',
				'font-size': '16px',
				'line-height': '26px'
			},
			button: {
				'float': 'right',
				'color': '#fff',
				'padding': '0.3em 1em'
			},
			emulateBootstrap3: {
				container: {
					'margin-right': 'auto',
					'margin-left': 'auto',
					'max-width': '1170px'
				},
				leftCol: {
					'padding': '0 15px',
					'width': '75%',
					'box-sizing': 'border-box',
					'display': 'inline-block',
					'vertical-align': 'top'
				},
				rightCol: {
					'padding': '0 15px',
					'width': '25%',
					'box-sizing': 'border-box',
					'display': 'inline-block',
					'vertical-align': 'top'
				}
			}
		},
		disableCss: false,
		emulateBootstrap3: false,
		template: function(data) {
			return  '<div class="container__' + data.contId + ' clearfix">\n' +
				'   <div class="container"><div class="row">\n' +
				'		<div class="js_fallbackStyle1 col-sm-9 col-md-10">' + data.text +
				'			<a href="' + data.link + '">' + data.linkText + '</a>\n' +
				'</div><div class="js_fallbackStyle2 col-sm-3 col-md-2">\n'+
				'			<a class="js_acceptCookies js_buttonStyle" href="javascript:void(0)">' + data.accept + '</a>\n' +
				'		</div>\n' +
				'   </div></div>\n' +
				'</div>';
		},
		messages: {
			'cs': {
				text: 'Tento web používá k&nbsp;poskytování funkcí sociálních médií a&nbsp;analýze návštěvnosti soubory cookies. Používáním tohoto webu souhlasíte s&nbsp;ukládáním a&nbsp;používáním souborů cookies.',
				link: '/cs/informace-o-webu',
				linkText: 'Více o&nbsp;ochraně osobních údajů.',
				accept: 'Rozumím'
			},
			'en': {
				text: 'This website uses cookies to provide social media functions and analyse the visit rate. By using this website, you agree to storage and use of cookies.',
				link: '/en/web-information',
				linkText: 'Read more about personal data protection.',
				accept: 'I agree'
			},
			'de': {
				text: 'Diese Webseite verwendet Cookies für die Funktionen der sozialen Medien und zur Analyse der Besucherzahlen. Durch Ihre Nutzung dieser Webseite stimmen Sie der Speicherung und Verwendung der Cookies zu.',
				link: '/de/informationen-uber-die-webseite',
				linkText: 'Mehr über den Schutz von personenbezogenen Daten.',
				accept: 'Ich verstehe'
			},
			'sk': {
				text: 'Táto webová lokalita používa na poskytovanie funkcií sociálnych médií návštevnosti súbory cookies. Používaním tejto webovej lokality súhlasíte s ukladaním a používaním súborov cookies.',
				link: '/sk/informacie-o-webe',
				linkText: 'Viac o ochrane osobných údajov.',
				accept: 'Rozumiem'
			},
			'ru': {
				text: 'Этот сайт использует файлы cookies в рамках предоставления социальных сетевых услуг, а также для анализа посещаемости веб-сайта. Пользуясь настоящим веб-сайтом, вы выражаете согласие с сохранением и использованием cookies.',
				link: '/ru/web-information',
				linkText: 'Подробнее об охране персональных данных.',
				accept: 'Понимаю'
			},
			'es': {
				text: 'Para las funciones de medios sociales y análisis de tráfico, este sitio web emplea archivos cookies. Al usar este sitio web expresa su consentimiento con el uso y la descarga de archivos cookies.',
				link: '/es/informacion-sobre-la-web',
				linkText: 'Más información sobre la protección de datos personales.',
				accept: 'Entiendo'
			}
		},

		// no need to edit, there are always default values
		containerId: null,
		cookieName: 'fg_cookie_policy_accepted'
	};

	/**
	 *
	 * @param element
	 * @param options
	 * @constructor
	 */
	var CookiesPolicy = function ( element, options ) {
		this.element = element;
		this.$t = $(this.element);

		this.state = {
			accepted: false
		};
		this.$banner = null;

		this.options = $.extend(true, {}, DEFAULTS, options );
		this._defaults = DEFAULTS;

		this.initialise_();
	};

	/**
	 * Init function - read options.cookieName status,
	 * @private
	 */
	CookiesPolicy.prototype.initialise_ = function() {
		if (!navigator.cookieEnabled) {
			return false;
		}
		this.checkCookieAccepted_();

		if (!this.state.accepted) {
			this.renderBanner_();
			this.bindEvents_();
		}
	};

	CookiesPolicy.prototype.renderBanner_ = function() {
		this.$banner = $(this.buildBannerCode_());
		var fixedPosition = {};
		if (this.options.position == 'top') {
			this.$banner.prependTo(this.$t);
			fixedPosition = { 'top': 0 };
		} else {
			this.$banner.appendTo(this.$t);
			fixedPosition = { 'bottom': 0 };
		}

		if (!this.options.disableCss) {
			this.applyBannerStyles_(fixedPosition);
			this.applyAnchorsStyles_();

			if (this.options.emulateBootstrap3) {
				this.emulateBootstrap3_();
			}
		}

		this.$acceptButton = $('a.js_acceptCookies', this.$banner);

	};

	CookiesPolicy.prototype.buildBannerCode_ = function() {
		return this.options.template($.extend(true, {}, {contId: this.options.containerId || PLUGIN_NAME }, this.options.messages[this.options.lang]));
	};

	CookiesPolicy.prototype.applyBannerStyles_ = function(posCss) {
		this.$banner.css($.extend(true, {}, posCss, this.options.css.panel));
	};

	CookiesPolicy.prototype.applyAnchorsStyles_ = function() {
		var self_ = this;
		$('a', this.$banner).css({
			'color': self_.options.css.brandColor
		});

		$('.js_buttonStyle', this.$banner).css({
			'background': self_.options.css.brandColor,
			'text-decoration': 'none'
		}).css(this.options.css.button);
	};

	/**
	 * emulates bootstrap 3 styles on container and col-xx-x divs
	 * @private
	 */
	CookiesPolicy.prototype.emulateBootstrap3_ = function() {
		var self_ = this;
		$('.container', this.$banner).css(self_.options.css.emulateBootstrap3.container || {});
		$('.js_fallbackStyle1', this.$banner).css(self_.options.css.emulateBootstrap3.leftCol || {});
		$('.js_fallbackStyle2', this.$banner).css(self_.options.css.emulateBootstrap3.rightCol || {});
	};

	CookiesPolicy.prototype.bindEvents_ = function() {
		var self_ = this;
		if (this.$acceptButton instanceof $) {
			this.$acceptButton.on('click', function(event) {
				event.preventDefault();
				self_.setCookieAccepted_();
				self_.destroy_();
			});
		}
	};

	/**
	 * updates internal state - saves value under the key to the this.state object
	 * @param key
	 * @param value
	 * @private
	 */
	CookiesPolicy.prototype.updateState_ = function(key, value) {
		this.state[key] = value;
	};

	/**
	 * reads cookie and sets internal state
	 * @private
	 */
	CookiesPolicy.prototype.checkCookieAccepted_ = function() {
		this.updateState_('accepted', $.cookie(this.options.cookieName) == '1');
	};

	CookiesPolicy.prototype.setCookieAccepted_ = function() {
		$.cookie(this.options.cookieName, '1', { path: '/', expires: 365 });
	};

	/**
	 * unbind events, remove banner element
	 * @private
	 */
	CookiesPolicy.prototype.destroy_ = function() {
		this.$acceptButton.off();
		switch (this.options.acceptEffect) {
			case 'fadeOut':
				this.$banner.fadeOut(function() {
					$(this).remove();
				});
				break;
			case 'slideUp':
			default:
				this.$banner.slideUp(function() {
					$(this).remove();
				});
		}
	};

	var API = {};

	/**
	 * plugin go live
	 * @param value - first param - decides, which action shall be executed
	 * 		if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
	 * 		if string && in API object - run method named as this value with all args[index > 0]
	 * @return {*}
	 */
	$.fn[PLUGIN_NAME] = function (value) {
		var args = arguments;

		return this.each(function () {
			var $this = $(this);

			// get plugin instance
			var plugin = $this.data('plugin_' + PLUGIN_NAME);

			// if there's not, create one
			if (!plugin) {
				plugin = new CookiesPolicy(this, value);
				$this.data('plugin_' + PLUGIN_NAME, plugin);
			}
			// if there is and first parameter is in predefined API methods, call it with rest of params
			else if (API[value]) {
				plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
			}
		});
	};

})( jQuery, window, document );



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/plugins/required/jquery.cookies-policy.js